import { ChatComponent } from './../../components/chat/chat.component';
import { AdvDetailComponent } from './../../../Adveristments/adv-detail/adv-detail.component';
import { Router } from '@angular/router';
import { MatAnchor, MatButton, MatDialog } from '@angular/material';
import { ConversationService } from './../../../Services/conversationService';
import { isNumber } from 'util';
import { MainService } from './../../../Services/service.service';

import { DTOAdvertisement } from './../../../api/WickedApiClient';
import { DTOAdvertisementEx } from './../../../api/LocalModels';
import { ActivatedRoute } from '@angular/router';
import { NgModule, Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, Renderer2, TemplateRef } from '@angular/core';
import { NgxSwiperConfig } from 'ngx-image-swiper';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-advertisement',
  templateUrl: './advertisement.component.html',
  styleUrls: ['./advertisement.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class AdvertisementComponent extends AdvDetailComponent implements OnInit {

    @ViewChild('btWrite', {static:false}) public btWrite: ElementRef;
    @ViewChild('textInputBar', {static:false}) public textInputBar: ChatComponent;;

  swiperConfig: NgxSwiperConfig = {
    navigationPlacement: 'inside',
    pagination: true,
    paginationPlacement: 'outside',
    imgBackgroundSize: 'contain'
  };
 
  public _advParam: DTOAdvertisementEx;
  public galleryImages: string[] = [];
  public canShowMap: boolean = false;
  public lat: number;
  public lng: number;
  public textInputBarActive: boolean = false;
  public watchingByAuthor: boolean = false;

  get advParam(): DTOAdvertisementEx {
      return this._advParam;
  }

  set advParam(value: DTOAdvertisementEx) {
      this._advParam = value;
  }

  get isUserAdmin(): boolean {
    return this.service.userService.isAdmin();
  }

  public isPremium: boolean = false;

  constructor(public route: ActivatedRoute, public service: MainService, public conversationService: ConversationService, public matDialog: MatDialog, public router: Router, private renderer: Renderer2) {
    super(route, service, conversationService, matDialog, router);
    service.pageName = "Ad";
    this.isPremium = this.service.userService.isPremium();
  }

  ngAfterViewInit(){
    this.renderer.listen('window', 'click',(e:Event)=>{
        if(this.btWrite && this.textInputBar && this.matDialog.openDialogs.length < 1){
            if(e.target !== this.btWrite.nativeElement && !this.textInputBar.elementRef.nativeElement.contains(e.target) && e.target !== this.textInputBar.elementRef.nativeElement ){
                this.textInputBarActive = false;
            }
        }
    });
  }

  public static initEmptyAdvMock(): DTOAdvertisementEx {
    const mock = new DTOAdvertisementEx();
    mock.title = "";
    mock.content = "";
    mock.images = [];

    return mock;

  }

  afterAdvLoad() {
    if (this.advParam) {

        const currentUserId = this.service.userService.getUserId();
        if(this.advParam.userId == currentUserId){
            this.watchingByAuthor = true;
        }

        this.conversationService.getActiveConversationId(this.advParam.advertisementId).toPromise().then(id => {
            this.existedConversationId = id;
        });

        this.markCurrentAdvertisementAsSeenIfNecessary(this.advParam);

        this.advParam.images = this.advParam.images || [];

        this.advParam.images.sort((a, b) => {
            return a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0;
        });


      this.advParam.images.forEach(v => {
        this.galleryImages.push(`${environment.apiBaseUrl}/FileGet/${v.fileName}/800x600`);
        });

        if (this.advParam.location && this.advParam.location != "") {
            const location = this.advParam.location.split("/").map(str => parseFloat(str));
            if (location.length == 2) {
                this.canShowMap = true;
                this.lat = location[0];
                this.lng = location[1];
            }

        }
        if (!this.canShowMap) {
            this.service.advService
                .getLocationDataByZipCode(this.advParam.zipCode)
                .toPromise()
                .then((v: any) => {
                    try {
                        if (v.results[0] && v.results[0].geometry.location.lat) {
                            this.canShowMap = true;
                            this.lat = v.results[0].geometry.location.lat;
                            this.lng = v.results[0].geometry.location.lng;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
        }

    }
  }

  public resolveAdvTitle(advParam: DTOAdvertisementEx) {
    if (!advParam) {
        return ""
    } else return advParam.title || '';
  }

  public get Location() {
    if (!this.advParam.isDemo) {
        return (this.advParam.subRegionName || this.advParam.regionShortName) ? (this.advParam.subRegionName + (this.advParam.regionShortName ? (", " + this.advParam.regionShortName) : "")) : "";
     } else {
       const subRegionName = this.advParam.subRegionName;
       if (subRegionName && subRegionName.trim() != "") {
         return subRegionName + (this.advParam.regionShortName ? (", " + this.advParam.regionShortName) : "");
       }
       else {
         let currentLocation = this.service.cookieService.get("current_location_text");
         if (currentLocation) {
           return currentLocation.split(",")[0]
         }
       }
    }
  }

    markCurrentAdvertisementAsSeenIfNecessary(adv: DTOAdvertisement) {
        if (this.service.userService.isAuthenticated() && (this.service.userService.isDemo() || this.service.userService.isAdmin()) && adv.isDemo == false && (adv.seen == false || adv.seenAdmin == false)) {
            this.service.advService.markAdvertisementAsSeen(adv.advertisementId, this.isUserAdmin).then(res => {
                this.advParam.seen = true;
                let index = this.service.advService.searchDataStandard.resultList.findIndex(i => i.advertisementId == adv.advertisementId);
                if (index > -1) {
                    if (this.service.userService.isDemo()) {
                        this.service.advService.searchDataStandard.resultList[index].seen = true;
                    }

                    if (this.service.userService.isAdmin()) {
                        this.service.advService.searchDataStandard.resultList[index].seenAdmin = true;
                    }


                }


            }).catch(err =>
                this.service.showError(err)
            )
        }
    }

    showTextInputBar(){
        this.textInputBarActive = true;
    }

    editAdv(id: string) {
        this.service.route.navigate([`adv-edit/${id}`]);
    }
}
